{
  "title": "Configuración",
  "subtitle": "Preferencias de tu cuenta y notificaciones.",
  "profile": {
    "title": "Perfil",
    "description": "Tu nombre es el que ven tus compañeros en tareas, comentarios y menciones.",
    "name_label": "Nombre",
    "name_placeholder": "Tu nombre y apellido",
    "email_label": "Correo",
    "email_hint": "Tu correo es la identidad con la que inicias sesión y no se puede cambiar desde aquí.",
    "errors": {
      "name_invalid": "Nombre inválido.",
      "generic": "No se pudo guardar."
    }
  },
  "workspace": {
    "title": "Workspace",
    "description": "El nombre con el que aparece tu workspace en el sidebar y en las invitaciones.",
    "name_label": "Nombre del workspace",
    "owner_only_hint": "Solo el dueño del workspace puede cambiar el nombre.",
    "errors": {
      "name_invalid": "Nombre inválido.",
      "not_owner": "Solo el dueño puede cambiar el nombre.",
      "generic": "No se pudo guardar."
    }
  },
  "notifications": {
    "title": "Notificaciones por email",
    "description": "Elige qué emails quieres recibir.",
    "loading": "Cargando preferencias...",
    "plan_gate": {
      "title": "Tu plan actual no incluye notificaciones por email",
      "description": "Las preferencias se guardan, pero los correos solo se envían en planes Pro o superior.",
      "cta": "Ver planes →"
    },
    "kinds": {
      "task_assigned": {
        "title": "Te asignan una tarea",
        "description": "Recibe un email cuando alguien te asigne a una tarea nueva."
      },
      "task_completed": {
        "title": "Completan una tarea que creaste",
        "description": "Recibe un email cuando alguien complete una tarea que tú creaste."
      },
      "comment_posted": {
        "title": "Comentan en tus tareas",
        "description": "Avisos cuando agreguen un comentario a una tarea de la que eres responsable o creador."
      },
      "user_mentioned": {
        "title": "Te mencionan",
        "description": "Cuando alguien te menciona con {'@'} en un comentario."
      }
    },
    "errors": {
      "load_failed": "No se pudieron cargar las preferencias.",
      "save_failed": "No se pudo guardar."
    }
  },
  "security": {
    "title": "Seguridad",
    "description": "Cambia tu contraseña.",
    "current_password_label": "Contraseña actual",
    "new_password_label": "Nueva contraseña",
    "new_password_hint": "Mínimo 8 caracteres.",
    "confirm_password_label": "Confirmar nueva contraseña",
    "show_password": "Mostrar contraseña",
    "hide_password": "Ocultar contraseña",
    "submit": "Cambiar contraseña",
    "saved": "Actualizada ✓",
    "errors": {
      "current_mismatch": "La contraseña actual no coincide.",
      "rate_limit": "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
      "generic": "No se pudo cambiar la contraseña."
    }
  },
  "language": {
    "title": "Idioma",
    "description": "Elige el idioma de la interfaz."
  },
  "apps": {
    "title": "Apps móviles",
    "description": "Lleva Tworks en el teléfono con la misma cuenta.",
    "ios_hint": "En iPhone y iPad instala la web app desde Safari: Compartir → Añadir a pantalla de inicio. La app nativa de iOS está en camino."
  },
  "api": {
    "title": "API",
    "description": "Genera llaves de API para integraciones externas. Consulta la documentación en /docs/api.",
    "docs_link": "Ver documentación",
    "empty": "Aún no tienes llaves de API.",
    "generate": "Generar llave",
    "scopes_label": "Permisos",
    "scope_read": "Leer tareas",
    "scope_write": "Crear tareas",
    "last_used": "Último uso",
    "never_used": "Sin uso",
    "revoke": "Revocar",
    "revoke_confirm": "¿Revocar esta llave? Las integraciones que la usen dejarán de funcionar.",
    "modal": {
      "title": "Nueva llave de API",
      "name_label": "Nombre",
      "name_placeholder": "Ej: Integración Zapier",
      "create": "Crear llave",
      "cancel": "Cancelar",
      "secret_title": "Copia tu llave ahora",
      "secret_warning": "No podrás verla de nuevo. Guárdala en un lugar seguro.",
      "copy": "Copiar",
      "copied": "¡Copiado!",
      "done": "Listo",
      "name_required": "El nombre es obligatorio.",
      "scope_required": "Selecciona al menos un permiso."
    }
  },
  "danger": {
    "title": "Zona peligrosa",
    "description": "Eliminar tu cuenta es permanente. Se borrarán tus tareas, proyectos, adjuntos y reuniones grabadas.",
    "delete_button": "Eliminar mi cuenta",
    "confirm_title": "¿Eliminar tu cuenta?",
    "confirm_body": "Escribe {word} para confirmar. Esta acción no se puede deshacer.",
    "confirm_word": "eliminar",
    "confirm_placeholder": "eliminar",
    "error": "No pudimos eliminar la cuenta. Intenta de nuevo."
  },
  "public_directory": {
    "title": "Página pública de solicitudes",
    "description": "Genera un enlace público de tu workspace donde cualquiera elige el equipo y el tablero al que quiere enviar su solicitud. Así centralizas todas las solicitudes en un solo lugar.",
    "enable_label": "Activar página pública del equipo",
    "link_label": "Enlace público del workspace",
    "copy": "Copiar",
    "copied": "¡Copiado!",
    "regenerate": "Regenerar enlace",
    "hint": "Muestra tus equipos y sus tableros con solicitudes activadas."
  }
}
